import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { TableFiltersProps } from 'modules/types'
import { FC } from 'react'
import { AClearFiltersButton } from 'views/components/Analytics'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { MonthFilter } from 'views/components/MonthFilter/MonthFilter'
import { SearchFilter } from 'views/components/SearchFilter/SearchFilter'
import { CropsFilter, TeamsFilter } from 'views/components/TableFilters'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { CommonRegionFilter } from 'views/components/TableFilters/RegionsFilters/CommonRegionFilter'
import { SampleStatusFilter } from './SampleStatusFilter'
import { endpoints } from 'modules/endpoints'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { useTranslation } from 'react-i18next'
import { BooleanFilter } from 'views/components/BooleanFilter/BooleanFilter'
import { SampleButtonFilters } from './SampleButtonFilters'
import styled from 'styled-components'

const ButtonsFilterContainer = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 16px;
`

export const SamplesFilters: FC<TableFiltersProps> = ({
  setListRequestParams,
  updateFilterState,
  listRequestParams,
}) => {
  const { t } = useTranslation('samples')
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
  })

  return (
    <div>
      <FiltersAndSearchWrapper>
        <FiltersWrapper>
          <MonthFilter value={listRequestParams.filter.month} updateFilterState={updateFilterState} allowClear={true} />
          <CropsFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
          <TeamsFilter
            listRequestParams={listRequestParams}
            updateFilterState={(data) => updateFilterState({ team: data.team, executor: undefined })}
          />
          <SampleStatusFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
          <CommonRegionFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
          <ABaseTableFilter
            id="responsibleFilter"
            onChange={(request_responsible) => updateFilterState({ request_responsible })}
            value={listRequestParams.filter.request_responsible}
            getLabel={(label) => label.full_name}
            endpoint={endpoints.sampleResponsibleCoordinators()}
            placeholder={t('common:responsible')}
            searchField="search"
          />
          <ABaseTableFilter
            id="createdFilter"
            onChange={(created_by) => updateFilterState({ created_by })}
            value={listRequestParams.filter.created_by}
            getLabel={(label) => label.full_name}
            endpoint={endpoints.taskAssignees()}
            placeholder={t('common:createdBy')}
            searchField="search"
            simpleApiFormat
          />
          <BooleanFilter
            onChange={(sent_to_export_bot) => updateFilterState({ sent_to_export_bot })}
            value={listRequestParams.filter.sent_to_export_bot}
            placeholder={t('sentToExportBot')}
          />
          <BooleanFilter
            onChange={(sent_to_local_bot) => updateFilterState({ sent_to_local_bot })}
            value={listRequestParams.filter.sent_to_local_bot}
            placeholder={t('sentToLocalBot')}
          />
        </FiltersWrapper>
        <SearchFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
      </FiltersAndSearchWrapper>
      <ButtonsFilterContainer>
        <SampleButtonFilters listRequestParams={listRequestParams} updateFilterState={updateFilterState} />

        {displayClearBtn && (
          <AClearFiltersButton
            onClick={() =>
              setListRequestParams({
                ...defaultListRequestParams,
              })
            }
          />
        )}
      </ButtonsFilterContainer>
    </div>
  )
}
